import React  from "react";
import { Button, ButtonGroup, Col } from "shards-react";
import useMedia from "../../modules/media/hooks";

function Pagination({ style }) {
  const { pageNumber, totalLength, fetchByPageNumber } = useMedia();

  const postPerPage= 10;
  const pageContainer = [];
  for (let i = 1; i <= Math.ceil(totalLength / postPerPage); i++) {
    pageContainer.push(i);
  }

  return (
    <div style={style} className="w-100">
      <ButtonGroup>
        {pageContainer.map(pg => (
          <Button
            key={pg}
            className="pagination_item"
            onClick={() => {
              fetchByPageNumber(pg);
            }}
            theme={pageNumber === pg ? "primary" : "white"}
          >
            {pg}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
}

export default Pagination;
